"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var firestore_1 = require("firebase/firestore");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var LiveWebLink_1 = __importDefault(require("./LiveWebLink"));
var ShareOnline_1 = __importDefault(require("./ShareOnline"));
var WebLinkPopover_1 = __importDefault(require("./WebLinkPopover"));
var ShareWebLink = function (_a) {
    var quoteReport = _a.quoteReport;
    var _b = __read(react_1.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleSharePopover = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleOnClose = function () { return setAnchorEl(null); };
    var selectQuoteReport = (0, react_1.useMemo)(function () { return (0, single_1.makeSelectQuoteReportByReportId)(quoteReport.id); }, [quoteReport.id]);
    var savedQuoteReportWExtras = (0, react_redux_1.useSelector)(selectQuoteReport);
    var _c = __read((0, hooks_1.useSubmitter)('quote_report_bundles', quoteReport.quoteReportBundleId), 2), submitReportBundle = _c[0], reportBundleIsSubmitting = _c[1];
    var toggleReportSharing = function (share) { return __awaiter(void 0, void 0, void 0, function () {
        var newQuoteReport, savedQuoteReport;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!quoteReport) {
                        return [2 /*return*/];
                    }
                    newQuoteReport = __assign(__assign({}, (0, omit_1.default)(quoteReport, ['serviceData', 'id', 'quoteReportBundleId'])), { isPublic: true });
                    savedQuoteReport = (0, omit_1.default)(savedQuoteReportWExtras, ['serviceData', 'id', 'quoteReportBundleId']);
                    if (!(quoteReport.quoteReportBundleId !== 'DUMMY_AUDIT' && (!(0, isEqual_1.default)(newQuoteReport, savedQuoteReport) || !share))) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitReportBundle({
                            quoteReportIds: (share ? firestore_1.arrayUnion : firestore_1.arrayRemove)(quoteReport.id),
                            serviceData: quoteReport.serviceData,
                            // ToDo: make fields ['serviceData', 'id', 'quoteReportBundleId'] as const
                            quoteReportsMap: (_a = {}, _a[quoteReport.id] = share ? newQuoteReport : (0, firestore_1.deleteField)(), _a),
                        })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var isShared = savedQuoteReportWExtras;
    var sharedUrl = "/quote-reports/".concat(quoteReport.serviceData.name, "/").concat(quoteReport.quoteReportBundleId, "?rId=").concat(quoteReport.id);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ title: "Publish online and share with a unique link", variant: "dark" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ onClick: handleSharePopover, icon: isShared ? pro_solid_svg_icons_1.faCheckCircle : undefined }, { children: !isShared ? 'Share' : 'Live Web Link' })) }) })), (0, jsx_runtime_1.jsxs)(WebLinkPopover_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: [!isShared && (0, jsx_runtime_1.jsx)(ShareOnline_1.default, { toggleShareableLink: toggleReportSharing, isSending: reportBundleIsSubmitting }), isShared && ((0, jsx_runtime_1.jsx)(LiveWebLink_1.default, { sharedUrl: sharedUrl, toggleShareableLink: toggleReportSharing, isSending: reportBundleIsSubmitting }))] }))] }));
};
exports.default = ShareWebLink;
